import Vue from 'vue';
import cookie from '../../cookie/cookie';
export default Vue.extend({
    name: 'select-notice',
    data: function () {
        return {
            usernameZh: '',
            selectForm: {
                messageModel: '',
            },
            currentMessage: '',
            selectRules: {
                messageModel: [
                    {
                        required: true,
                        message: '请选择发送的短信模板',
                        trigger: 'change',
                    },
                ],
            },
            isUpload: false,
            isImport: false,
            isTry: false,
            isShowFailOpe: false,
            isUploadComplete: false,
            uploadVolidate: false,
            uploadStatus: '',
            uploadUrl: '/proxy/file/msg/send/upload',
            templateDownConfig: {
                href: 'javascript:void(0)',
                isDisabled: true,
            },
            downloadUrl: '',
            tipsTxt: '',
            importStatus: {
                errorStatus: false,
                successStatus: false,
                warnStatus: false,
            },
            file: '',
            loading2: false,
            key: '',
            templateCode: '',
        };
    },
    props: {
        options: {
            type: Array,
            default: function () {
                return [];
            },
            required: true,
        },
    },
    created: function () {
        this.getUserName();
    },
    methods: {
        getUserName: function () {
            this.usernameZh = cookie.getCookie('usernameZh');
        },
        nextStep: function () {
            var _this = this;
            this.$refs['selectForm'].validate(function (valid) {
                if (!valid) {
                    return;
                }
                if (!_this.uploadVolidate) {
                    _this.isUploadComplete = true;
                    return;
                }
                _this.$emit('to-sure', {
                    active: 1,
                    templateCode: _this.templateCode,
                    uploadKey: _this.key,
                });
            });
        },
        showMsg: function (value) {
            var _this = this;
            this.options.forEach(function (item) {
                if (item.templateCode === value) {
                    _this.currentMessage = item.sendContent;
                    _this.templateCode = item.templateCode;
                    _this.$emit('show-current-msg', item.sendExample);
                    _this.isUpload = true;
                    _this.templateDownConfig = {
                        href: 'https://img-hxy021.didistatic.com/static/strategymis/do1_8dVhhwTyGVPlIyvVhBzP',
                        isDisabled: false,
                    };
                }
            });
        },
        beforeUploadValidate: function (file) {
            var fileArr = file.name.split('.');
            var name = fileArr[fileArr.length - 1];
            var reg = /^xlsx|xls$/;
            this.isUploadComplete = false;
            if (!reg.test(name)) {
                this.$confirm('', '', {
                    message: '<p class="title">仅支持xlsx或xls格式文件</p>',
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '知道了',
                    showClose: false,
                    type: 'error',
                    showCancelButton: false,
                });
                return false;
            }
        },
        customRequest: function (_a) {
            var file = _a.file;
            this.loading2 = true;
            this.file = file;
            this.uploadMsg(file);
        },
        uploadError: function () {
            this.tipsTxt = '上传失败,请重试';
            this.isImport = true;
            this.isTry = true;
            this.loading2 = false;
            this.importStatus = {
                errorStatus: true,
                successStatus: false,
                warnStatus: false,
            };
        },
        repeatUpload: function () {
            // if (this.uploadStatus === 'FAIL') {
            this.isUpload = true;
            this.isTry = false;
            this.isImport = false;
            this.loading2 = false;
            // }
        },
        uploadMsg: function (file) {
            var _this = this;
            this.$request({
                method: 'post',
                url: "/proxy/file/msg/send/upload",
                data: {
                    file: file,
                    creator: this.usernameZh,
                },
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                transformRequest: function (data) {
                    var formData = new FormData();
                    for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
                        var key = _a[_i];
                        if (data[key] != null) {
                            formData.append(key, data[key]);
                        }
                    }
                    return formData;
                },
            }).then(function (res) {
                if (!res || res.errorCode || !res.data.result) {
                    _this.loading2 = false;
                    _this.isImport = true;
                    _this.isTry = true;
                    _this.tipsTxt = '上传失败,请重试';
                    _this.importStatus = {
                        errorStatus: true,
                        successStatus: false,
                        warnStatus: false,
                    };
                    return;
                }
                _this.key = res.data.uploadKey;
                return _this.checkUploadStatus();
            });
        },
        getUploadStatus: function () {
            return this.$request({
                method: 'post',
                url: "/proxy/api/msg/send/status",
                data: {
                    uploadKey: this.key,
                },
            });
        },
        checkUploadStatus: function () {
            var _this = this;
            var pollingMain = function () {
                _this.getUploadStatus().then(function (res) {
                    var data = res.data;
                    var uploadStatus = data.uploadStatus, failFilePath = data.failFilePath, sendCount = data.sendCount;
                    _this.$store.commit('info/update', {
                        sendCount: sendCount.toString(),
                    });
                    if (uploadStatus && uploadStatus === 'SUCCESS') {
                        _this.tipsTxt = '已成功导入';
                        _this.uploadStatus = 'SUCCESS';
                        _this.importStatus = {
                            errorStatus: false,
                            successStatus: true,
                            warnStatus: false,
                        };
                    }
                    if (!res || res.errorCode || uploadStatus === 'FAIL') {
                        _this.loading2 = true;
                        _this.isImport = true;
                        _this.tipsTxt = '导入失败,请点击重试';
                        _this.isTry = true;
                        _this.uploadStatus = 'FAIL';
                        _this.importStatus = {
                            errorStatus: true,
                            successStatus: false,
                            warnStatus: false,
                        };
                        _this.isShowFailOpe = true;
                        _this.downloadUrl = failFilePath;
                        return;
                    }
                    if (uploadStatus === 'LOADING') {
                        _this.uploadStatus = 'LOADING';
                        setTimeout(function () {
                            pollingMain();
                        }, 1000);
                        return;
                    }
                    _this.loading2 = true;
                    _this.isImport = true;
                    _this.uploadVolidate = true;
                    if (uploadStatus === 'PART') {
                        _this.tipsTxt = '导入完成，部分导入失败';
                        _this.uploadStatus = 'PART';
                        _this.importStatus = {
                            errorStatus: false,
                            successStatus: false,
                            warnStatus: true,
                        };
                        _this.isShowFailOpe = true;
                        return (_this.downloadUrl = failFilePath);
                    }
                });
            };
            setTimeout(function () {
                pollingMain();
            }, 1000);
        },
        downloadFail: function () {
            window.open(this.downloadUrl);
        },
    },
});
